import { useTheme } from '../contexts/ThemeContext';
import { useLang }  from '../contexts/LangContext';
import styles from './ThemeSwitcher.module.css';

export default function ThemeSwitcher() {
  const { theme, toggle } = useTheme();
  const { t } = useLang();
  return (
    <button
      id="btn-theme-toggle"
      className={styles.switcher}
      onClick={toggle}
      title={theme === 'dark' ? t('theme.light') : t('theme.dark')}
    >
      {theme === 'dark' ? '☀️' : '🌙'}
    </button>
  );
}
